import api from "./baseApi";
import endpoints from "./endpoints";

export const getDashboard = async () => {
  try {
    const res = await api.get(endpoints.dashboard.base);

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to load dashboard data";

    throw new Error(message);
  }
};